/**
 * Container and file storage APIs
 * https://loopback.io/doc/en/lb3/Storage-component.html
 */

import { loopbackDelete } from '..';
import LoopbackProvider from '../LoopbackProvider';

export const uploadFile = (containerName: string, file: FormData): Promise<unknown> => fetch(
  `${LoopbackProvider.loopbackHost}Containers/${containerName}/upload`, {
    method: 'POST',
    headers: {
      Authorization: LoopbackProvider.loopbackToken.id,
    },
    body: file,
  },
);

export const deleteFile = (container: string, file: string): Promise<unknown> => loopbackDelete(`Containers/${container}/files/${file}`);
